import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Compra, Convenio, FuncaoService, Login, Rcms } from 'eddydata-lib';
import { CompraService, RcmsService } from 'compra-lib';
import { ConvenioService } from '../service/convenio.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'lib-convenio-saldo',
  templateUrl: './convenio-saldo.component.html',
})
export class ConvenioSaldoComponent implements OnInit, OnChanges, OnDestroy {

  @Input() login: Login;
  @Input() entidade: Convenio;

  protected unsubscribe: Subject<void> = new Subject();

  public convenio: any;
  public valorConcedente = 0;
  public valorAditamentos = 0;
  public valorReajuste = 0;
  public valorRendimentos = 0;
  public valorEstorno = 0;
  public valorCompra = 0;
  public valorRequisicao = 0;
  public valorEmpenho = 0;
  public totalConcedente = 0;
  public valorContrapartida = 0;
  public valorContraAditamentos = 0;
  public valorContraReajuste = 0;
  public valorContraEstorno = 0;
  public valorContraCompra = 0;
  public valorContraRequisicao = 0;
  public valorContraEmpenho = 0;
  public totalContrapartida = 0;

  constructor(
    protected convenioService: ConvenioService,
    protected compraService: CompraService,
    protected rcmsService: RcmsService,
    protected funcaoService: FuncaoService,
  ) {
  }

  ngOnInit() {
    // this.convenioService.saldoConvenio(this.entidade.id, this.login.orgao.id)
    //   .pipe(takeUntil(this.unsubscribe)).subscribe(async (convenio) => {
    //     this.convenio = convenio;
    //   }, error => this.funcaoService.acaoErro(error));

    this.convenioService.extendido(1, -1, {
      'id': this.entidade.id, 'orgao.id': this.login.orgao.id
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe(
        async convenio => {
          // console.log(convenio)
          this.convenio = convenio.content;
          await this.calcularValores(convenio.content[0]);

        },
        () => alert('erro ao retornar lista')
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  private async calcularValores(convenio: any) {
    this.valorEmpenho = +convenio.total_empenho;
    this.valorContraEmpenho = +convenio.total_empenho_contra;
    this.valorReajuste = +convenio.total_reajuste_ajuste;
    this.valorContraReajuste = +convenio.total_reajuste_contra_ajuste;
    this.valorRendimentos = +convenio.total_rendimentos;
    this.valorEstorno = +convenio.total_estorno_ajuste;
    this.valorContraEstorno = +convenio.total_estorno_contra_ajuste;
    this.valorAditamentos = +convenio.total_aditamentos;
    this.valorContraAditamentos = +convenio.total_contra_aditamentos;
    this.valorConcedente = +convenio.valor_convenio - +convenio.valor_contrapartida;
    this.valorContrapartida = +convenio.valor_contrapartida;

    // Rcms

    const rcms = await (await this.rcmsService.extendido(0, -1, {
      relations: 'setor,itens.cotacoes,licitacao,contrato,orgao,ficha.despesa,ficha.recurso,ficha.aplicacao,ficha.aplicacao_variavel,subelemento,requerente,modalidade,prazo,compras',
      'convenio.id': this.entidade.id,
      'orgao.id': this.login.orgao.id,
      'count_compra': 0,
      'itens.cotacoes.id$not_null': true,
      'excluido': false,
      'ignoreCondObrig': true,
    }).toPromise()).content as Rcms[];

    if (rcms?.length) {
      for (const r of rcms) {
        const rcmsRecurso = r.ficha?.recurso?.codigo;
        const rcmsAplicacao = r.ficha?.aplicacao?.codigo;
        const rcmsVariavel = r.ficha?.aplicacao_variavel?.codigo;

        if (convenio?.recurso_contra && convenio?.aplicacao_contra && convenio?.aplicacao_variavel_contra && convenio?.recurso_contra?.codigo === rcmsRecurso && convenio?.aplicacao_contra?.codigo === rcmsAplicacao && convenio?.aplicacao_variavel_contra?.codigo === rcmsVariavel) {
          this.valorContraRequisicao += +r.itens.reduce((acc, i) => acc += +i.cotacoes[0].valor_unitario * +i.quantidade, 0);
        } else {
          this.valorRequisicao += +r.itens.reduce((acc, i) => acc += +i.cotacoes[0].valor_unitario * +i.quantidade, 0);
        }
      }
    }

    // Compras
    const compras = await (await this.compraService.extendido(0, -1, {
      relations: 'rcms.setor,licitacao,contrato,orgao,ficha.despesa,ficha.recurso,ficha.aplicacao,ficha.aplicacao_variavel,subelemento,empenho',
      'convenio.id': this.entidade.id,
      'orgao.id': this.login.orgao.id,
      'exercicio.id': this.login.exercicio.id,
      'empenho.id$null': true,
      'excluido': false,
      'ignoreCondObrig': true,
    }).toPromise()).content as Compra[];

    if (compras?.length) {
      for (const c of compras) {
        const compraRecurso = c.ficha?.recurso?.codigo;
        const compraAplicacao = c.ficha?.aplicacao?.codigo;
        const compraVariavel = c.ficha?.aplicacao_variavel?.codigo;

        if (convenio?.recurso_contra && convenio?.aplicacao_contra && convenio?.aplicacao_variavel_contra && convenio?.recurso_contra?.codigo === compraRecurso && convenio?.aplicacao_contra?.codigo === compraAplicacao && convenio?.aplicacao_variavel_contra?.codigo === compraVariavel) {
          this.valorContraRequisicao += +c.total_compra;
        } else {
          this.valorCompra += +c.total_compra;
        }
      }
    }

    this.totalConcedente = this.valorConcedente + this.valorAditamentos + this.valorReajuste - Math.abs(this.valorEstorno) - this.valorRequisicao - this.valorCompra - this.valorEmpenho + this.valorRendimentos;
    this.totalContrapartida = this.valorContrapartida + this.valorContraAditamentos + this.valorContraReajuste - Math.abs(this.valorContraEstorno) - this.valorContraRequisicao - this.valorContraCompra - this.valorContraEmpenho;
  }

}
